
import { defineComponent } from "vue";

export default defineComponent({
  name: "ErrorBlock",
  props: ["errors"],
});
